module.exports = __webpack_public_path__ + "img/vertical_3_6_9006.50d4f9f6.png";